import tags from 'collections/tagsInstance'
import fetchOncePromise from 'libraries/fetchOncePromise'

export default fetchOncePromise(tags);


